/** Trilha 5b (Conversas substitui o Digisac): etiquetas, prioridade, presença, horário, menu de entrada e palavras-chave, nos três idiomas (sem travessão nem emoji). */
const pt = {
  t5b: {
    etiquetas: 'Etiquetas',
    prioridade: 'Prioridade',
    prioridades: { baixa: 'Baixa', normal: 'Normal', alta: 'Alta', urgente: 'Urgente' },
    classificar: 'Etiquetas',
    classificarTitulo: 'Etiquetas e prioridade',
    ajudaEtiquetas: 'Separe por vírgula. Até 10, com até 30 caracteres cada.',
    classificado: 'Conversa atualizada',
    todasEtiquetas: 'Todas as etiquetas',
    todasPrioridades: 'Todas as prioridades',
    menuPendente: 'No menu de entrada',
    presenca: 'Disponível para atender',
    presencaAjuda: 'Na distribuição por menor carga, você recebe conversas enquanto está disponível com a caixa aberta.',
    distribuicaoMenorCarga: 'Menor carga',
    ajudaMenorCarga: 'Menor carga: vai a quem está disponível (com a caixa aberta) e tem menos conversas ativas, até o limite.',
    limite: 'Conversas por atendente',
    ajudaLimite: 'Na menor carga, ninguém recebe acima deste número de conversas ativas. Vazio: sem limite.',
    membroCarga_one: '{{count}} ativa',
    membroCarga_other: '{{count}} ativas',
    membroDisponivel: 'disponível',
    horario: {
      titulo: 'Horário de atendimento',
      usar: 'Atender só no horário definido',
      ajuda: 'No fuso do workspace. Fora do horário, a mensagem abaixo sai uma vez por conversa em cada período fechado.',
      dias: { '0': 'Domingo', '1': 'Segunda', '2': 'Terça', '3': 'Quarta', '4': 'Quinta', '5': 'Sexta', '6': 'Sábado' },
      fechado: 'Fechado',
      inicio: 'Início',
      fim: 'Fim',
      adicionarFaixa: 'Adicionar faixa',
      removerFaixa: 'Remover a faixa {{n}} de {{dia}}',
      inicioDe: 'Início da faixa {{n}} de {{dia}}',
      fimDe: 'Fim da faixa {{n}} de {{dia}}',
      feriados: 'Feriados (dia inteiro fechado)',
      adicionarFeriado: 'Adicionar feriado',
      removerFeriado: 'Remover o feriado {{data}}',
      mensagem: 'Mensagem fora do horário',
      ajudaMensagem: 'Vazia: nenhuma mensagem automática. No WhatsApp oficial, sai só como resposta ao contato (dentro da janela de 24 horas).',
    },
    automacoes: {
      menuTitulo: 'Menu de entrada',
      menuAjuda: 'A conversa nova (ou reaberta) recebe esta mensagem com as opções, e a resposta leva à fila. Três respostas fora das opções levam à fila padrão do canal.',
      semMenu: 'Sem menu neste canal: a conversa nova entra na fila do canal.',
      criarMenu: 'Montar menu',
      editarMenu: 'Editar menu',
      ativo: 'Menu ativo',
      inativo: 'Menu desligado',
      mensagem: 'Mensagem inicial',
      opcoes: 'Opções',
      rotulo: 'Nome da opção {{n}}',
      filaOpcao: 'Fila da opção {{n}}',
      adicionarOpcao: 'Adicionar opção',
      removerOpcao: 'Remover a opção {{n}}',
      mensagemInvalida: 'Resposta para opção inválida',
      ajudaInvalida: 'O menu vai junto. Vazia: "Não entendi a opção. Responda com o número."',
      salvo: 'Menu salvo',
      remover: 'Remover menu',
      removerTitulo: 'Remover o menu deste canal?',
      removerTexto: 'A conversa nova volta a entrar direto na fila do canal. Quem esperava a escolha vai à fila padrão na próxima mensagem.',
      removido: 'Menu removido',
      semFilas: 'Crie uma fila ativa antes de montar o menu.',
      conflito: 'Outra pessoa gravou este menu depois que você abriu. O que você digitou continua aqui; reabra com a versão atual para ver o que ela gravou (o seu rascunho se perde).',
      reabrirAtual: 'Reabrir com a versão atual',
      exigeTodas: 'O menu e as palavras-chave valem para o workspace inteiro: só quem vê todas as empresas muda.',
      palavrasTitulo: 'Respostas por palavra-chave',
      palavrasAjuda: 'Quando a mensagem do contato tem uma das palavras, a resposta sai na hora. A mesma resposta não se repete na conversa em 30 minutos. Não vale no e-mail nem no portal.',
      nova: 'Nova resposta automática',
      palavras: 'Palavras',
      ajudaPalavras: 'Separe por vírgula. Casa a palavra inteira, sem diferenciar acento nem maiúscula.',
      resposta: 'Resposta',
      canal: 'Canal',
      todosCanais: 'WhatsApp e Instagram',
      fila: 'Fila',
      qualquerFila: 'Qualquer fila',
      ativa: 'Ativa',
      inativa: 'Inativa',
      vazio: 'Nenhuma resposta automática ainda.',
      removerRegraTitulo: 'Remover esta resposta automática?',
      removerRegraTexto: 'Ela deixa de responder às mensagens novas.',
    },
  },
};

type Dic = typeof pt;

const en: Dic = {
  t5b: {
    etiquetas: 'Labels',
    prioridade: 'Priority',
    prioridades: { baixa: 'Low', normal: 'Normal', alta: 'High', urgente: 'Urgent' },
    classificar: 'Labels',
    classificarTitulo: 'Labels and priority',
    ajudaEtiquetas: 'Separate with commas. Up to 10, with up to 30 characters each.',
    classificado: 'Conversation updated',
    todasEtiquetas: 'All labels',
    todasPrioridades: 'All priorities',
    menuPendente: 'In the entry menu',
    presenca: 'Available to answer',
    presencaAjuda: 'With least-load distribution, you receive conversations while you are available with the inbox open.',
    distribuicaoMenorCarga: 'Least load',
    ajudaMenorCarga: 'Least load: goes to whoever is available (inbox open) and has the fewest active conversations, up to the limit.',
    limite: 'Conversations per agent',
    ajudaLimite: 'With least load, nobody receives more than this number of active conversations. Empty: no limit.',
    membroCarga_one: '{{count}} active',
    membroCarga_other: '{{count}} active',
    membroDisponivel: 'available',
    horario: {
      titulo: 'Business hours',
      usar: 'Answer only during set hours',
      ajuda: 'In the workspace time zone. Outside business hours, the message below is sent once per conversation in each closed period.',
      dias: { '0': 'Sunday', '1': 'Monday', '2': 'Tuesday', '3': 'Wednesday', '4': 'Thursday', '5': 'Friday', '6': 'Saturday' },
      fechado: 'Closed',
      inicio: 'Start',
      fim: 'End',
      adicionarFaixa: 'Add time range',
      removerFaixa: 'Remove range {{n}} of {{dia}}',
      inicioDe: 'Start of range {{n}} on {{dia}}',
      fimDe: 'End of range {{n}} on {{dia}}',
      feriados: 'Holidays (closed all day)',
      adicionarFeriado: 'Add holiday',
      removerFeriado: 'Remove holiday {{data}}',
      mensagem: 'Out-of-hours message',
      ajudaMensagem: 'Empty: no automatic message. On the official WhatsApp it is only sent as a reply to the contact (within the 24-hour window).',
    },
    automacoes: {
      menuTitulo: 'Entry menu',
      menuAjuda: 'A new (or reopened) conversation receives this message with the options, and the answer leads to the queue. Three answers outside the options lead to the channel default queue.',
      semMenu: 'No menu on this channel: new conversations go to the channel queue.',
      criarMenu: 'Build menu',
      editarMenu: 'Edit menu',
      ativo: 'Menu on',
      inativo: 'Menu off',
      mensagem: 'Opening message',
      opcoes: 'Options',
      rotulo: 'Option {{n}} name',
      filaOpcao: 'Option {{n}} queue',
      adicionarOpcao: 'Add option',
      removerOpcao: 'Remove option {{n}}',
      mensagemInvalida: 'Reply to an invalid option',
      ajudaInvalida: 'The menu is sent along. Empty: "I did not understand the option. Reply with the number."',
      salvo: 'Menu saved',
      remover: 'Remove menu',
      removerTitulo: 'Remove the menu of this channel?',
      removerTexto: 'New conversations go straight to the channel queue again. Whoever was choosing goes to the default queue on the next message.',
      removido: 'Menu removed',
      semFilas: 'Create an active queue before building the menu.',
      conflito: 'Someone else saved this menu after you opened it. What you typed is still here; reopen with the current version to see what they saved (your draft is lost).',
      reabrirAtual: 'Reopen with the current version',
      exigeTodas: 'The menu and keywords apply to the whole workspace: only someone who sees all companies can change them.',
      palavrasTitulo: 'Keyword replies',
      palavrasAjuda: 'When the contact message has one of the words, the reply goes out right away. The same reply is not repeated in the conversation within 30 minutes. Not used on email or the portal.',
      nova: 'New automatic reply',
      palavras: 'Words',
      ajudaPalavras: 'Separate with commas. Matches the whole word, ignoring accents and case.',
      resposta: 'Reply',
      canal: 'Channel',
      todosCanais: 'WhatsApp and Instagram',
      fila: 'Queue',
      qualquerFila: 'Any queue',
      ativa: 'Active',
      inativa: 'Inactive',
      vazio: 'No automatic replies yet.',
      removerRegraTitulo: 'Remove this automatic reply?',
      removerRegraTexto: 'It stops answering new messages.',
    },
  },
};

const es: Dic = {
  t5b: {
    etiquetas: 'Etiquetas',
    prioridade: 'Prioridad',
    prioridades: { baixa: 'Baja', normal: 'Normal', alta: 'Alta', urgente: 'Urgente' },
    classificar: 'Etiquetas',
    classificarTitulo: 'Etiquetas y prioridad',
    ajudaEtiquetas: 'Separa con comas. Hasta 10, con hasta 30 caracteres cada una.',
    classificado: 'Conversación actualizada',
    todasEtiquetas: 'Todas las etiquetas',
    todasPrioridades: 'Todas las prioridades',
    menuPendente: 'En el menú de entrada',
    presenca: 'Disponible para atender',
    presencaAjuda: 'En la distribución por menor carga, recibes conversaciones mientras estás disponible con la bandeja abierta.',
    distribuicaoMenorCarga: 'Menor carga',
    ajudaMenorCarga: 'Menor carga: va a quien está disponible (con la bandeja abierta) y tiene menos conversaciones activas, hasta el límite.',
    limite: 'Conversaciones por agente',
    ajudaLimite: 'En la menor carga, nadie recibe más de este número de conversaciones activas. Vacío: sin límite.',
    membroCarga_one: '{{count}} activa',
    membroCarga_other: '{{count}} activas',
    membroDisponivel: 'disponible',
    horario: {
      titulo: 'Horario de atención',
      usar: 'Atender solo en el horario definido',
      ajuda: 'En la zona horaria del workspace. Fuera del horario, el mensaje de abajo sale una vez por conversación en cada período cerrado.',
      dias: { '0': 'Domingo', '1': 'Lunes', '2': 'Martes', '3': 'Miércoles', '4': 'Jueves', '5': 'Viernes', '6': 'Sábado' },
      fechado: 'Cerrado',
      inicio: 'Inicio',
      fim: 'Fin',
      adicionarFaixa: 'Agregar franja',
      removerFaixa: 'Quitar la franja {{n}} de {{dia}}',
      inicioDe: 'Inicio de la franja {{n}} del {{dia}}',
      fimDe: 'Fin de la franja {{n}} del {{dia}}',
      feriados: 'Feriados (día entero cerrado)',
      adicionarFeriado: 'Agregar feriado',
      removerFeriado: 'Quitar el feriado {{data}}',
      mensagem: 'Mensaje fuera del horario',
      ajudaMensagem: 'Vacío: ningún mensaje automático. En el WhatsApp oficial, sale solo como respuesta al contacto (dentro de la ventana de 24 horas).',
    },
    automacoes: {
      menuTitulo: 'Menú de entrada',
      menuAjuda: 'La conversación nueva (o reabierta) recibe este mensaje con las opciones, y la respuesta lleva a la cola. Tres respuestas fuera de las opciones llevan a la cola predeterminada del canal.',
      semMenu: 'Sin menú en este canal: la conversación nueva entra en la cola del canal.',
      criarMenu: 'Armar menú',
      editarMenu: 'Editar menú',
      ativo: 'Menú activo',
      inativo: 'Menú apagado',
      mensagem: 'Mensaje inicial',
      opcoes: 'Opciones',
      rotulo: 'Nombre de la opción {{n}}',
      filaOpcao: 'Cola de la opción {{n}}',
      adicionarOpcao: 'Agregar opción',
      removerOpcao: 'Quitar la opción {{n}}',
      mensagemInvalida: 'Respuesta para opción inválida',
      ajudaInvalida: 'El menú va junto. Vacía: "No entendí la opción. Responde con el número."',
      salvo: 'Menú guardado',
      remover: 'Quitar menú',
      removerTitulo: '¿Quitar el menú de este canal?',
      removerTexto: 'La conversación nueva vuelve a entrar directo en la cola del canal. Quien esperaba la elección va a la cola predeterminada en el próximo mensaje.',
      removido: 'Menú quitado',
      semFilas: 'Crea una cola activa antes de armar el menú.',
      conflito: 'Otra persona guardó este menú después de que lo abriste. Lo que escribiste sigue aquí; vuelve a abrirlo con la versión actual para ver lo que guardó (tu borrador se pierde).',
      reabrirAtual: 'Reabrir con la versión actual',
      exigeTodas: 'El menú y las palabras clave valen para todo el workspace: solo quien ve todas las empresas los cambia.',
      palavrasTitulo: 'Respuestas por palabra clave',
      palavrasAjuda: 'Cuando el mensaje del contacto tiene una de las palabras, la respuesta sale en el momento. La misma respuesta no se repite en la conversación en 30 minutos. No vale en el correo ni en el portal.',
      nova: 'Nueva respuesta automática',
      palavras: 'Palabras',
      ajudaPalavras: 'Separa con comas. Coincide con la palabra entera, sin distinguir acentos ni mayúsculas.',
      resposta: 'Respuesta',
      canal: 'Canal',
      todosCanais: 'WhatsApp e Instagram',
      fila: 'Cola',
      qualquerFila: 'Cualquier cola',
      ativa: 'Activa',
      inativa: 'Inactiva',
      vazio: 'Todavía no hay respuestas automáticas.',
      removerRegraTitulo: '¿Quitar esta respuesta automática?',
      removerRegraTexto: 'Deja de responder a los mensajes nuevos.',
    },
  },
};

export const t5b = { pt, en, es };
